export default {
  'conditional.title': 'Condición',
  'conditional.error.noGroups': 'Add at least one condition group before saving.',

  'conditional.form.valueSource': 'Origen Valor',

  'conditional.form': 'Formulario',
  'conditional.field': 'Campo',

  'conditional.menu.condition': 'CONDITION',
  'conditional.menu.group': 'GROUP',
  'conditional.menu.collapseGroups': 'Colapsar Grupos',
  'conditional.menu.expandGroups': 'Expandir Grupos',

  'conditional.form.variable': 'Variable',
  'conditional.form.operator': 'Operador',
  'conditional.form.value': 'Value',

  'conditional.form.form': 'Formulario',
  'conditional.form.field': 'Campo',
  'conditional.form.iterationStepData': 'Datos de Iteración',

  'conditional.form.select.FormField': 'Formulario / Campo',
  'conditional.form.select.Variable': 'Variable',
  'conditional.form.select.IterationStepData': 'Datos de Iteración',
};
